var _rect, _rect2, _ellipse, _circle, _path, _g, _g2, _g3, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.2148,
    y: 2.86694,
    width: 1.88082,
    height: 7.21588,
    rx: 0.940409,
    transform: "rotate(34.2415 44.2148 2.86694)",
    fill: "#24E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.0625,
    y: 4.35913,
    width: 1.88082,
    height: 7.21588,
    rx: 0.940409,
    transform: "rotate(-40.7585 6.0625 4.35913)",
    fill: "#24E0E0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.8121,
    cy: 2.45795,
    rx: 2.41557,
    ry: 2.45795,
    fill: "url(#paint0_linear_24192_126971)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.2205,
    cy: 2.99976,
    r: 2.44932,
    transform: "rotate(-75 6.2205 2.99976)",
    fill: "url(#paint1_linear_24192_126971)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6401 3.2207C26.5142 3.2207 26.3631 3.2207 26.2372 3.2207C26.0358 3.2207 25.8092 3.2207 25.6077 3.2207C11.4568 3.2207 0 14.6745 0 28.8218C0 42.9691 11.4568 54.4229 25.6077 54.4229C28.1509 54.4229 30.0897 54.1963 32.4063 53.5167C32.0286 55.3291 31.4242 58.7527 28.8307 61.2196C42.0249 59.533 53.5068 43.7495 53.5068 30.0805C53.4817 15.2535 41.4709 3.2207 26.6401 3.2207Z",
    fill: "url(#paint2_linear_24192_126971)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_24192_126971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.1866,
    cy: 1.1866,
    r: 1.1866,
    transform: "matrix(1 0 0 -1 20.7656 16.5276)",
    fill: "#FC9AA2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_24192_126971)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.14422,
    cy: 1.1866,
    rx: 1.14422,
    ry: 1.1866,
    transform: "matrix(1 0 0 -1 25.8516 16.5276)",
    fill: "#FFC747"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_24192_126971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.1866,
    cy: 1.1866,
    r: 1.1866,
    transform: "matrix(1 0 0 -1 30.8516 16.5276)",
    fill: "#24F9D3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7372 19.3237H36.8654C41.8244 19.3237 45.8545 23.3539 45.8545 28.3129V30.4104C45.8545 35.3694 41.8244 39.3995 36.8654 39.3995H18.7372C13.7782 39.3995 9.74805 35.3694 9.74805 30.4104V28.3129C9.74805 23.3539 13.7782 19.3237 18.7372 19.3237Z",
    fill: "url(#paint3_linear_24192_126971)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7283 19.9177H36.8728C41.5514 19.9177 45.3453 23.6999 45.3453 28.3641V30.457C45.3453 35.1211 41.5514 38.9033 36.8728 38.9033H18.7283C14.0497 38.9033 10.2559 35.1211 10.2559 30.457V28.3641C10.2559 23.6999 14.0497 19.9177 18.7283 19.9177Z",
    stroke: "#628EED",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0163 27.0127C35.9946 27.2213 36.8375 27.8767 37.3793 28.4874C37.4846 28.5917 37.4846 28.7556 37.4094 28.8896C37.289 29.1131 36.9729 29.128 36.7923 28.9492C36.3257 28.4874 35.6635 28.0406 34.926 27.8767C34.0982 27.6979 33.1801 27.9065 32.3071 28.9045C32.1416 29.0982 31.8406 29.0833 31.7051 28.8748C31.6299 28.7556 31.6299 28.5917 31.7202 28.4874C32.7888 27.1021 33.9778 26.8042 35.0163 27.0127ZM22.0124 27.0127C22.9907 27.2213 23.8335 27.8767 24.3753 28.4874C24.4807 28.5917 24.4807 28.7556 24.4054 28.8896C24.285 29.1131 23.969 29.128 23.7884 28.9492C23.3218 28.4874 22.6595 28.0406 21.9221 27.8767C21.0943 27.6979 20.1762 27.9065 19.3032 28.9045C19.1376 29.0982 18.8366 29.0833 18.7012 28.8748C18.6259 28.7556 18.6259 28.5917 18.7162 28.4874C19.7848 27.1021 20.9739 26.8042 22.0124 27.0127Z",
    fill: "#A0FFF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24192_126971",
    x: 19.7656,
    y: 13.1543,
    width: 4.37305,
    height: 4.37329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_24192_126971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_24192_126971",
    x: 24.8516,
    y: 13.1543,
    width: 4.28906,
    height: 4.37329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_24192_126971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_24192_126971",
    x: 29.8516,
    y: 13.1543,
    width: 4.37305,
    height: 4.37329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_24192_126971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24192_126971",
    x1: 45.8121,
    y1: 0,
    x2: 45.8121,
    y2: 4.9159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24192_126971",
    x1: 6.2205,
    y1: 0.550437,
    x2: 6.2205,
    y2: 5.44908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24192_126971",
    x1: -42.4209,
    y1: 109.209,
    x2: 116.629,
    y2: -41.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#366EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8613,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24192_126971",
    x1: 24.0908,
    y1: 20.963,
    x2: 36.6007,
    y2: 49.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D07B0",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/Chatbot.e3edda75.svg";
export { ForwardRef as ReactComponent };